import React, { Component } from 'react';
import {
  Route,
  BrowserRouter as Router,
  Switch,
  Redirect,
} from 'react-router-dom';
import Home from './pages/Home';
import Chat from './pages/Chat';
import { auth } from './services/firebase';
import './styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function PrivateRoute({ component: Component, authenticated, ...rest }) {
  return (
    <Route
      {...rest}
      render = {
        (props) => authenticated === true
          ? <Component {...props} />
          : <Redirect to={{ pathname: '/', state: { from: props.location }}} />
      }
    />
  )
}

function PublicRoute({ component: Component, authenticated, ...rest}) {
  return (
    <Route
      {...rest}
      render = {
        (props) => authenticated === false
          ? <Component {...props} />
          : <Redirect to='/chat' />
      }
    />
  )
}

class App extends Component {
  constructor() {
    super();
    this.state = {
      authenticated: false,
      loading: true,
    }
  }

  componentDidMount() {
    auth().onAuthStateChanged((user) => {
      if (user) {
        this.setState({
          authenticated: true,
          loading: false,
        });
      } else {
        this.setState({
          authenticated: false,
          loading: false,
        });
      }
    })
  }

  render() {
    return this.state.loading === true ? (
      <div className='spinner-border text-success' role='status'>
        <span className='sr-only'>Loading...</span>
      </div>
    ) : (
      <Router>
        <Switch>
          <PrivateRoute
            path="/chat"
            authenticated={this.state.authenticated}
            component={Chat}
          />
          <PublicRoute
            path="/"
            authenticated={this.state.authenticated}
            component={Home}
          />
        </Switch>
      </Router>
    )
  }
}

export default App;